import { useRef } from "react";
import Blaze from "@swiggy-private/blaze.js";
import { useEffectOnce } from "hooks/useEffectOnce";
import { allowMetricCapture } from "utils/monitoring";
import { isBrowserEnv } from "utils/headers";

const EMPTY_FUNCTION = () => void 0;

export function useBootstrap(nbEventTypePrefix: string): void {
    const initRef = useRef(false);

    if (!initRef.current && allowMetricCapture()) {
        // init blaze
        Blaze.init({
            sendToAnalytics: EMPTY_FUNCTION,
            enableResourceTiming: true,
            nrConfig: {
                enable: true,
                config: {
                    NR_ENDPOINT: "https://insights-collector.newrelic.com/v1/accounts/737486/events", // enter newrelic endpoint here
                    NR_KEY: "e1687c0399396561695f01042f298f764ad2b997", // enter newrelic key here
                },
                meta: {
                    appName: nbEventTypePrefix, // enter app name
                    /* JS hash is generated without replacing with actual value
                   So cached file would be same for both canary vs non-canary, and would have unknown behavior */
                    appDeployName: isBrowserEnv()
                        ? (document.querySelector("[data-app-name]") as HTMLDivElement)?.dataset.appName ?? ""
                        : "",
                },
            },
        });
    }

    useEffectOnce(() => {
        initRef.current = true;
    });
}
